import { styled } from '@vebox/etui-system';
import { Component, Children, isValidElement, cloneElement, createElement } from 'react';
import { _ as _objectWithoutProperties, a as _objectSpread2, c as _defineProperty, b as _extends } from '../_rollupPluginBabelHelpers-3b7bd988.js';
import { Div } from '@vebox/etui-system-elements';
import '../Svg-0180d7b5.js';
import '../Icon/Icon.js';
import '@vebox/etui-icons';
import '../Icon/icons.js';
import '../Icon/helper.js';
import TabsList from './TabsList.js';
import Tab from './Tab.js';
import '../ScrollingMenu/defaultSettings.js';
import '../ScrollingMenu/utils/index.js';
import '../ScrollingMenu/InnerWrapper.js';
import '../ScrollingMenu/ScrollingMenu.js';
import '../ScrollingMenu/ArrowWrapper.js';

const _excluded = ["theme"];
const TabsDiv = styled(Div).attrs(_ref => {
  let {
      theme
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return _objectSpread2({
    position: 'relative',
    width: '100%',
    borderBottom: `1px solid ${theme.palette.divider}`,
    overflow: 'hidden'
  }, props);
})``;

class Tabs extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "valueToIndex", new Map());
  }
  renderActiveTabContent() {
    const {
      value,
      onChange,
      children
    } = this.props;
    this.valueToIndex = new Map();
    let childIndex = 0;
    return Children.map(children, child => {
      const tab = child;
      if (! /*#__PURE__*/isValidElement(child)) {
        return null;
      }
      const childValue = tab.props.value === undefined ? childIndex : tab.props.value;
      this.valueToIndex.set(childValue, childIndex);
      const isActive = childValue === value;
      const {
        styles
      } = tab.props;
      childIndex += 1;
      return /*#__PURE__*/cloneElement(tab, {
        isActive,
        onChange,
        styles,
        count: Children.count(children),
        value: childValue,
        key: childValue
      });
    });
  }
  render() {
    const {
      styles,
      testId
    } = this.props;
    return /*#__PURE__*/createElement(TabsDiv, _extends({}, styles.root, {
      testId: testId
    }), /*#__PURE__*/createElement(TabsList, {
      styles: styles.tabsList
    }, this.renderActiveTabContent()));
  }
}
_defineProperty(Tabs, "Tab", Tab);
_defineProperty(Tabs, "defaultProps", {
  styles: {},
  testId: 'tabsComponent'
});

export default Tabs;
